/* eslint-disable */

import React from "react";
import RaindropClickable from "../raindrop-clickable/raindrop-clickable.tsx";
import { Size } from "../../logic/enums.ts";
import { useNavigate } from "react-router-dom";
import RaindropSparkleFlame from "../raindrop-sparkle-flame/raindrop-sparkle-flame.tsx";

const StreakDisplay = ({ streak, size = Size.Medium, showNumber = true }) => {
  const navigate = useNavigate();

  let tailwindTextSize = "text-2xl";
  let tailwindIconSize = "text-4xl";
  let tailwindGap = "gap-4";
  let tailwindIconBackgroundColor =
    "bg-gradient-to-br from-orange-500 to-red-500";

  switch (size) {
    case Size.Small:
      tailwindTextSize = "text-lg";
      tailwindIconSize = "text-2xl";
      tailwindGap = "gap-2";
      break;
    case Size.Huge:
      tailwindTextSize = "text-8xl";
      tailwindIconSize = "text-9xl";
      tailwindGap = "gap-6";
      break;
  }

  if (!streak) {
    tailwindIconBackgroundColor = "bg-gradient-to-br from-gray-500 to-gray-700";
    streak = 0;
  }

  return (
    <RaindropClickable
      onClick={() => {
        navigate("/raindrop/bombshell");
      }}
    >
      <div
        className={`flex flex-row ${tailwindGap} items-center justify-center `}
      >
        <div
          className={`flex relative items-center justify-center ${tailwindIconBackgroundColor} bg-clip-text text-transparent`}
        >
          {/* {streak && <RaindropSparkleFlame />} */}
          <i className={`fas fa-fire  ${tailwindIconSize} text-transparent `} />
        </div>
        {showNumber && (
          <p className={`font-black ${tailwindTextSize}`}>{streak}</p>
        )}
      </div>
    </RaindropClickable>
  );
};

export default StreakDisplay;
